<template>
  <div class="bottom-switch">
    <!--切换一开始-->
    <div class="bottom-content"
         style="height:100%;">
      <!--具体内容开始-->
      <div class="clearfix swiper-container"
           :class="['bottom-content'+blockData.sno]">
        <div class="intel-top swiper-wrapper">
          <div class="intel-ite clearfix swiper-slide"
               v-for="(ite,k) in listData"
               :key="k"
               v-show="k==0||centerStyle!=''"
               @click="$emit('emitHandleDetail',ite)"
               @contextmenu.stop.prevent="listData?$emit('emitContextMenuItem',k,$event):''"
               @touchstart="touchstarts(k)"
               @touchmove="touchmoves()"
               @touchend="touchends()">
            <div class="intel-top-left fl"
                 v-if="listData.length">
              <a href="javascript:;">
                <ZImage :value="ite.pictures&&ite.pictures[0]?ite.pictures[0]:''"
                        :error-src="require('../../assets/image/images/default_media.png')" />
              </a>
            </div>
            <div class="intel-top-right fl"
                 v-if="ite">
              <div :class="[ind==0?'intel-title':'intel-price']"
                   v-for="(cont,ind) in ite.others"
                   v-show="ind < 5"
                   :key="cont.id"><span v-if="cont.standardName && ind > 0">{{cont.standardName}}：</span>{{allPrice(cont.standardEnName) ? formatPrice(cont.standardData) : cont.standardData}}</div>
              <!-- <div class="intel-btn" v-for="(btn,ind) in ite.btns" :key="ind" v-show="ind<3">
                            <a class="btn-more blue" @click.stop.prevent="optionClick(btn,ite)">{{btn.standardName}}</a>
                        </div> -->
            </div>
          </div>
        </div>
        <div class="intel-bot">
          <ul>
            <li v-for="(ite,ind) in listData"
                @click="$emit('emitHandleDetail',ite)"
                @contextmenu.stop.prevent="listData?$emit('emitContextMenuItem',ind,$event):''"
                @touchstart="touchstarts(ind)"
                @touchmove="touchmoves()"
                @touchend="touchends()"
                :key="ind"
                v-show="ind>0 && ((7 - ind)>=tabLeftRightLen)">
              <a href="javascript:;"
                 class="text">
                <ZImage :value="ite.pictures&&ite.pictures[0]?ite.pictures[0]:''"
                        :error-src="require('../../assets/image/images/default_media.png')" />
              </a>
              <div class="intel-bot-tit">
                <a v-if="ite.others.length"
                   href="javascript:;">{{ite.others[0]?ite.others[0].standardData:''}}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!--具体内容结束-->
    </div>
    <!--切换一结束-->
  </div>
</template>
    <script>
import ZImage from "../ZImage.vue"
export default {
  name: 'knowledgeCenter',
  components: {
    ZImage
  },
  props: {
    blockData: {
      type: Object
    },
    centerStyle: {
      require: true,
      default: "knowledgeCenter"
    },
    listData: {
      type: Array
    },
    tabLeftRightLen: {
      type: Number
    }
  },
  data () {
    return {
      timeOutEvent: 0
    }
  },
  methods: {
    touchstarts (ind) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emitContextMenuItem', ind);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
  }

}
    </script>
    
    <style lang="scss" scoped>
/*具体内容开始*/
.intel-top {
  overflow: hidden;
  margin-bottom: 10px;
}
.intel-top .intel-top-left {
  width: 280px;
  height: 187px;
  margin-right: 20px;
  overflow: hidden;
}
.intel-top .intel-top-left a img {
  width: 280px;
  height: 187px;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  -moz-transition: all 0.3s linear;
  -o-transition: all 0.3s linear;
}
.intel-top .intel-top-left img:hover {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
  -ms-transform: scale(1.1);
}
.intel-top .intel-top-right {
  width: calc(100% - 300px);
  width: -moz-calc(100% - 300px);
  width: -webkit-calc(100% - 300px);
}
.intel-top .intel-top-right .intel-title {
  font-size: 20px;
  color: #0d78cf;
  font-weight: 600;
  height: 42px;
  line-height: 42px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.intel-top .intel-top-right .intel-price {
  font-size: 14px;
  color: #666;
  height: 26px;
  line-height: 26px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.intel-top .intel-top-right .intel-det {
  font-size: 14px;
  color: #666;
  height: 73px;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-wrap: break-word;
}
.intel-top .intel-top-right .intel-btn {
  margin-top: 10px;
  display: inline-block;
}
.intel-top .intel-top-right .intel-btn .btn-more {
  display: block;
  height: 36px;
  line-height: 36px;
  padding: 0 25px;
  font-size: 14px;
  color: #fff;
  border-radius: 3px;
  margin-right: 10px;
}
.intel-top .intel-top-right .intel-btn .btn-more.blue {
  background: #2f8eed;
}
.intel-top .intel-top-right .intel-btn .btn-more.green {
  background: #12bca6;
}
.intel-top .intel-top-right .intel-btn .btn-more:hover {
  filter: brightness(1.1);
  -webkit-filter: brightness(1.1);
}

/* 企业简介 banner样式 */
.companyIntroduce .intel-bot {
  display: none;
}
.companyIntroduce .intel-top {
  height: 443px;
  overflow: visible;
}
.companyIntroduce .intel-top .intel-top-left {
  height: 443px;
  width: calc(50% - 20px);
}
.companyIntroduce .intel-top .intel-top-left a img {
  width: 100%;
  height: 443px;
  display: block;
}
.companyIntroduce .intel-top .intel-top-right {
  width: 50%;
  height: 443px;
}
.banner .intel-bot {
  display: none;
}
.banner .intel-top {
  height: 443px;
  overflow: visible;
}
.banner .intel-top .intel-top-left {
  height: 443px;
  width: 100%;
}
.banner .intel-top .intel-top-left a img {
  width: 100%;
  height: 443px;
  display: block;
}
.banner .intel-top .intel-top-right {
  display: none;
}

.intel-bot {
}
.intel-bot ul {
  width: 100%;
  overflow: hidden;
}
.intel-bot ul li {
  margin-top: 10px;
  margin-left: 14px;
  width: 144px;
  height: 212px;
  border: 1px solid #ddd;
  overflow: hidden;
  float: left;
}
.intel-bot ul li:nth-of-type(2) {
  margin-left: 0;
}
.intel-bot ul li a {
  display: block;
}
.intel-bot ul li a.text {
  line-height: 180px;
  height: 180px;
  font-size: 0;
  text-align: center;
  display: block;
}
.intel-bot ul li .intel-bot-tit a {
  padding: 0 16px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.intel-bot ul li:hover a img {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
  -ms-transform: scale(1.1);
}
.intel-bot ul li img {
  vertical-align: middle;
  width: 112px;
  height: 142px;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  -moz-transition: all 0.3s linear;
  -o-transition: all 0.3s linear;
}
.intel-bot ul li .intel-bot-tit {
  width: 100%;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid #ddd;
  font-size: 16px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: #fafafa;
  color: #333;
}
.intel-bot ul li a > .z-image {
  /deep/ .el-image__inner {
    width: 100%;
    height: auto;
    vertical-align: middle;
  }
}
/*具体内容结束*/

/* 超小屏幕（手机，小于 768px） */
@media screen   and (max-width: 767px) {
  .right-content .bottom-switch,
  .bottom-content {
    height: auto;
  }
  .outreach_content
    .block-content
    .right-content
    .content-center
    .bottom-switch {
    height: auto;
  }
  .intel-top .intel-top-right .intel-title {
    font-size: 16px;
  }
  .intel-bot ul li .intel-bot-tit {
    font-size: 12px;
    height: 30px;
    line-height: 30px;
  }
  .intel-top .intel-top-right .intel-price {
    font-size: 12px;
    margin-top: -10px;
  }
  .intel-top {
    margin-bottom: 0;
  }
  .intel-top .intel-top-left,
  .intel-top .intel-top-left a img,
  .intel-top .intel-top-right,
  .intel-bot ul li img {
    width: 100%;
  }
  .intel-bot ul li {
    width: calc(50% - 7px);
    width: -webkit-calc(50% - 7px);
    margin-left: 0px;
    margin-top: 10px;
  }
  .intel-bot ul li:nth-of-type(odd) {
    margin-left: 10px;
  }
  .intel-bot ul li a.text {
    line-height: unset;
  }
  .intel-bot ul li {
    height: unset;
  }
  .intel-bot ul li a > .z-image {
    line-height: 180px;
  }
  .content-left-box,
  .content-right-box {
    width: 150px;
    position: absolute;
    top: 0px;
    bottom: 0px;
    z-index: 9;
    background: #fff;
    border-left: 1px solid #dddddd;
    border-right: 1px solid #dddddd;
    height: auto;
  }
  .content-left-box {
    left: 0;
  }
  .content-right-box {
    right: -1px;
  }
  .block-content {
    position: relative;
  }
  .btn-left,
  .btn-right {
    position: absolute;
    top: 160px;
    width: 30px;
    height: 30px;
    border-radius: 20px;
    z-index: 8;
    background-size: contain;
  }
  .btn-left {
    left: 2px;
    background-image: url("~@/assets/image/images/icons/arrow_right_circular.png");
  }
  .btn-right {
    right: 2px;
    background-image: url("~@/assets/image/images/icons/arrow_left_circular.png");
  }
  .close-left,
  .close-right {
    position: absolute;
    top: 10px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    z-index: 10;
    background-size: contain;
    background-image: url("~@/assets/image/images/icons/close_right_top.png");
  }
  .close-left {
    left: 120px;
  }
  .close-right {
    right: 120px;
  }
}
/* 超小屏幕（手机，小于 768px） */
@media (min-width: 768px) and (max-width: 1200px) {
  .outreach_content
    .block-content
    .right-content
    .content-center
    .bottom-switch {
    height: auto;
  }
  .intel-bot ul li {
    width: calc(25% - 12px);
    width: -webkit-calc(25% - 12px);
  }
  .intel-bot ul li {
    margin: 5px !important;
  }
  //  .intel-bot ul li:nth-child(5n){margin-left:0;}
}
</style>
    
    


// WEBPACK FOOTER //
// src/components/floorBlock/knowledgeCenter.vue